module.exports = __webpack_public_path__ + "img/云南省老年病医院.5b7f0651.png";